import { Activity, Users, Shield } from "lucide-react";
import { usePublicStatus, useVpnProfiles } from "@/api/queries";
import { Card, CardBody, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export function DashboardPage() {
  const { data: profiles } = useVpnProfiles({ page: 1, page_size: 1 });
  const { data: status } = usePublicStatus();

  const activeServers = status?.servers.filter((s) => s.status === "up").length ?? 0;

  return (
    <div className="space-y-8">
      <header>
        <span className="label">Обзор</span>
        <h1 className="font-display text-3xl font-bold mt-2">Контроль контура</h1>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        <Stat
          icon={<Users className="text-accent" size={20} />}
          label="VPN-профилей"
          value={profiles?.total ?? "—"}
          accent
        />
        <Stat
          icon={<Shield className="text-state-success" size={20} />}
          label="Серверов в пуле"
          value={`${activeServers} / ${status?.servers.length ?? 0}`}
        />
        <Stat
          icon={<Activity className="text-state-info" size={20} />}
          label="Версия API"
          value={status?.version ?? "—"}
          muted
        />
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Узлы инфраструктуры</CardTitle>
        </CardHeader>
        <CardBody className="space-y-3">
          {status?.servers.map((s) => (
            <div
              key={s.slug}
              className="flex items-center justify-between py-2 border-b border-border/50 last:border-0"
            >
              <div>
                <div className="font-medium">{s.slug}</div>
                <div className="text-xs text-fg-subtle mt-0.5">{s.role}</div>
              </div>
              <Badge tone={s.status === "up" ? "success" : "danger"}>{s.status}</Badge>
            </div>
          ))}
          {!status && (
            <div className="text-sm text-fg-subtle py-4">Загрузка статусов…</div>
          )}
        </CardBody>
      </Card>
    </div>
  );
}

function Stat({
  icon,
  label,
  value,
  accent,
  muted,
}: {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  accent?: boolean;
  muted?: boolean;
}) {
  return (
    <Card className={accent ? "border-accent/30 shadow-glow" : ""}>
      <CardBody>
        <div className="flex items-center justify-between">
          <span className="label">{label}</span>
          {icon}
        </div>
        <div
          className={`font-display text-3xl font-bold mt-3 ${muted ? "text-fg-muted" : ""}`}
        >
          {value}
        </div>
      </CardBody>
    </Card>
  );
}
